export default "__VITE_ASSET__879b1f42__"